import React from 'react';

const GoogleLogo = () => (
  <svg
    width="87"
    height="26"
    viewBox="0 0 87 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10931_16391)">
      <circle cx="13.918" cy="12" r="12" fill="white" />
    </g>
    <g clipPath="url(#clip0_10931_16391)">
      <path
        d="M21.5979 12.1832C21.5979 11.6159 21.5469 11.0705 21.4524 10.5469H13.918V13.645H18.2234C18.0343 14.6414 17.467 15.485 16.6161 16.0522V18.0668H19.2124C20.7251 16.6704 21.5979 14.6195 21.5979 12.1832Z"
        fill="#4285F4"
      />
      <path
        d="M13.9191 20C16.079 20 17.8899 19.2873 19.2135 18.0655L16.6172 16.0509C15.9045 16.5309 14.9954 16.8218 13.9191 16.8218C11.8391 16.8218 10.0718 15.4182 9.43912 13.5273H6.77734V15.5928C8.09369 18.2036 10.7918 20 13.9191 20Z"
        fill="#34A853"
      />
      <path
        d="M9.43792 13.5194C9.27792 13.0394 9.18337 12.5304 9.18337 11.9995C9.18337 11.4686 9.27792 10.9595 9.43792 10.4795V8.41406H6.77614C6.23069 9.49041 5.91797 10.7049 5.91797 11.9995C5.91797 13.294 6.23069 14.5085 6.77614 15.5849L8.84883 13.9703L9.43792 13.5194Z"
        fill="#FBBC05"
      />
      <path
        d="M13.9191 7.18541C15.0972 7.18541 16.1445 7.59267 16.9808 8.37812L19.2717 6.08724C17.8826 4.79272 16.079 4 13.9191 4C10.7918 4 8.09369 5.79634 6.77734 8.41448L9.43912 10.4799C10.0718 8.58902 11.8391 7.18541 13.9191 7.18541Z"
        fill="#EA4335"
      />
    </g>
    <path
      d="M55.3212 14.4745C55.3212 17.0642 53.2953 18.9725 50.809 18.9725C48.3228 18.9725 46.2969 17.0642 46.2969 14.4745C46.2969 11.8666 48.3228 9.97656 50.809 9.97656C53.2953 9.97656 55.3212 11.8666 55.3212 14.4745ZM53.346 14.4745C53.346 12.8562 52.1718 11.749 50.809 11.749C49.4462 11.749 48.2721 12.8562 48.2721 14.4745C48.2721 16.0766 49.4462 17.2 50.809 17.2C52.1718 17.2 53.346 16.0745 53.346 14.4745Z"
      fill="white"
    />
    <path
      d="M65.0516 14.4745C65.0516 17.0642 63.0257 18.9725 60.5395 18.9725C58.0532 18.9725 56.0273 17.0642 56.0273 14.4745C56.0273 11.8686 58.0532 9.97656 60.5395 9.97656C63.0257 9.97656 65.0516 11.8666 65.0516 14.4745ZM63.0764 14.4745C63.0764 12.8562 61.9023 11.749 60.5395 11.749C59.1767 11.749 58.0025 12.8562 58.0025 14.4745C58.0025 16.0766 59.1767 17.2 60.5395 17.2C61.9023 17.2 63.0764 16.0745 63.0764 14.4745Z"
      fill="white"
    />
    <path
      d="M74.3884 10.2483V18.3235C74.3884 21.6453 72.4294 23.002 70.1135 23.002C67.9335 23.002 66.6214 21.5439 66.1266 20.3514L67.8463 19.6356C68.1525 20.3677 68.9028 21.2316 70.1115 21.2316C71.5939 21.2316 72.5125 20.317 72.5125 18.5953V17.9484H72.4436C72.0015 18.4939 71.1498 18.9704 70.075 18.9704C67.826 18.9704 65.7656 17.0114 65.7656 14.4907C65.7656 11.9518 67.826 9.97656 70.075 9.97656C71.1477 9.97656 71.9995 10.4531 72.4436 10.9824H72.5125V10.2503H74.3884V10.2483ZM72.6525 14.4907C72.6525 12.9069 71.5959 11.749 70.2514 11.749C68.8886 11.749 67.7469 12.9069 67.7469 14.4907C67.7469 16.0583 68.8886 17.2 70.2514 17.2C71.5959 17.2 72.6525 16.0583 72.6525 14.4907Z"
      fill="white"
    />
    <path d="M77.4734 5.51562V18.6972H75.5469V5.51562H77.4734Z" fill="white" />
    <path
      d="M84.9748 15.9569L86.508 16.979C86.0131 17.7111 84.8207 18.9725 82.7603 18.9725C80.2052 18.9725 78.2969 16.9973 78.2969 14.4745C78.2969 11.7997 80.2214 9.97656 82.5393 9.97656C84.8735 9.97656 86.0152 11.8341 86.3883 12.838L86.5931 13.349L80.5803 15.8393C81.0407 16.7417 81.7565 17.2021 82.7603 17.2021C83.7662 17.2021 84.4638 16.7073 84.9748 15.9569ZM80.2559 14.3386L84.2752 12.6697C84.0542 12.1079 83.389 11.7165 82.6062 11.7165C81.6024 11.7165 80.2052 12.6027 80.2559 14.3386Z"
      fill="white"
    />
    <path
      d="M39.0015 13.3023V11.3941H45.4321C45.495 11.7266 45.5274 12.1201 45.5274 12.5459C45.5274 13.9776 45.136 15.748 43.8746 17.0094C42.6477 18.287 41.0802 18.9684 39.0036 18.9684C35.1545 18.9684 31.918 15.8332 31.918 11.9842C31.918 8.13518 35.1545 5 39.0036 5C41.1329 5 42.6498 5.83551 43.7895 6.92451L42.4429 8.27105C41.6257 7.50449 40.5184 6.90828 39.0015 6.90828C36.1908 6.90828 33.9925 9.17348 33.9925 11.9842C33.9925 14.7949 36.1908 17.0601 39.0015 17.0601C40.8246 17.0601 41.8629 16.328 42.5281 15.6629C43.0675 15.1234 43.4224 14.3528 43.5623 13.3003L39.0015 13.3023Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_10931_16391"
        x="0.917969"
        y="0"
        width="26"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10931_16391"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10931_16391"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_10931_16391">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(5.91797 4)"
        />
      </clipPath>
    </defs>
  </svg>
);

GoogleLogo.displayName = 'GoogleLogo';
export default GoogleLogo;
